var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pure-radio-slide',{attrs:{"label":_vm.$t(_vm.setting.label),"selections":_vm.setting.options.map(function (ref) {
	var label = ref.label;
	var value = ref.value;

	return ({ label: _vm.$t(label), value: value });
})},on:{"change":_vm.handleChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }